<template>
  <section class="w-full flex items-center justify-center border border-slate-100"  >
    <div class="relative w-full h-full flex justify-center items-center cursor-pointer" @click="isModalShow = true">
      <NuxtImg
        width="1000"
        loading="lazy"
        class="w-full rounded-md overflow-hidden"
        :src="item.img"
        :alt="alt"
      />
      <span class="flex justify-center absolute items-center fill-white bg-blue-600 w-8 h-8 lg:w-32 lg:h-32 aspect-square rounded-full">
        <IconPlay class=" w-2/5 relative ml-1"/>
      </span>
    </div>
    <SectionModalVideo :src="item.video" :isShow="isModalShow" @close="isModalShow = false"  />
  </section>
</template>

<script setup>
defineProps({
  item: Object,
  alt: String
})
const isModalShow = ref(false)

</script>
